import { useMemo } from "react"
import PropTypes from "prop-types"
import { ERROR } from "helpers/data-statuses"
import Error from "components/error"
import { MetricsTemplateShape } from "components/custom-metrics-selector/helpers/prop-types"
import { combineTanStackStatuses } from "helpers/data-statuses"
import { FORECAST } from "helpers/shapes/simulator"
import { useModelBetaFields } from "resources/beta"
import { useTemplateMetadata } from "resources/templates"
import { useModelId } from "connected-components/dashboard/hooks/use-model-id"
import { useAssetViewData } from "connected-components/asset-view/hooks/use-asset-view-data"
import AssetViewCustomComponent from "./component"
import MetricsSelectorWrapper from "./metrics-selector"
import { getInitialDuplicateSelectedMetrics } from "components/custom-metrics-selector/helpers/template-metrics"

export default function AssetViewCustom({ modelMetadata, templateMetadata, instrumentsWithMetadata, availableMetrics, flattenedMetrics, betaInstrument, selectedMetrics, setSelectedMetrics, customSelectedMetrics, forecasts, ...props }) {
  const { duplicateFromViewName, duplicateFromTemplateId, duplicateFromViewMetrics } = useAssetViewData()
  const modelId = useModelId()
  const [modelBetaFields, modelBetaFieldsStatus] = useModelBetaFields(modelId)
  const [duplicateSourceMetadata] = useTemplateMetadata(duplicateFromTemplateId)
  const status = combineTanStackStatuses([modelBetaFieldsStatus])

  const initialSelectedMetrics = useMemo(() => getInitialDuplicateSelectedMetrics({
    duplicateFromTemplateId,
    duplicateFromViewMetrics,
    duplicateSourceMetrics: duplicateSourceMetadata?.config?.metrics,
    modelId,
  }), [duplicateFromTemplateId, duplicateFromViewMetrics, duplicateSourceMetadata?.config?.metrics, modelId])

  if (status === ERROR) {
    return <Error />
  }

  return <>
    <MetricsSelectorWrapper
      modelMetadata={modelMetadata}
      selectedMetrics={selectedMetrics}
      templateMetadata={templateMetadata}
      setSelectedMetrics={setSelectedMetrics}
      availableMetrics={availableMetrics}
      flattenedMetrics={flattenedMetrics}
      initialViewName={duplicateFromViewName}
      initialSelectedMetrics={initialSelectedMetrics}
      duplicateSourceTemplateId={duplicateFromTemplateId}
    />
    <AssetViewCustomComponent
      betaFields={modelBetaFields}
      betaInstrument={betaInstrument}
      forecasts={forecasts}
      templateMetadata={templateMetadata}
      instrumentsWithMetadata={instrumentsWithMetadata}
      selectedMetrics={selectedMetrics}
      customSelectedMetrics={customSelectedMetrics}
      {...props}
    />
  </>
}

AssetViewCustom.propTypes = {
  modelMetadata: PropTypes.object.isRequired,
  templateMetadata: MetricsTemplateShape,
  instrumentsWithMetadata: PropTypes.object.isRequired,
  availableMetrics: PropTypes.array.isRequired,
  flattenedMetrics: PropTypes.array.isRequired,
  betaInstrument: PropTypes.object.isRequired,
  customSelectedMetrics: PropTypes.arrayOf(PropTypes.object),
  selectedMetrics: PropTypes.arrayOf(PropTypes.object),
  setSelectedMetrics: PropTypes.func,
  forecasts: PropTypes.arrayOf(FORECAST),
}
